import { CompanyAdminLayout } from "../../components/CompanyAdmin/CompanyAdminLayout";
import React from "react";

const NewRoutersPage = () => {
  return (
    <>
      <CompanyAdminLayout>
        <div className="p-5 relative">
          <div className="relative mb-[28px] / flex flex-col items-start gap-[0.5rem]">
            <h2 className="text-[1.375rem] / font-semibold">
              데이터 수집기 관리
            </h2>
            <span className="text-[1rem] font-normal">
              총 1개의 데이터 수집기가 있습니다.
            </span>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
            <div className="p-5 bg-[#F9FAFB] rounded-2xl outline outline-[#E8E8E8] outline-1">
              <div className="flex items-center gap-5 mb-3">
                <div
                  className="ml-5 flex flex-row pointer-events-none select-none"
                  draggable={false}
                >
                  {/* Make it not selectable*/}
                  <div className="w-[140px] h-[140px] scale-[1.7]">
                    <img src={"/assets/images/router.png"} alt="printer" />
                  </div>
                </div>
                <div className="text-start">
                  <h2 className="font-bold text-xl">디자인 바라 1층 작업실</h2>
                  <span>PODRUT-244</span>
                </div>
              </div>
              <div className="flex justify-start gap-3">
                <div className="bg-[#4285F4] w-full text-white p-4 rounded-2xl">
                  <h3 className="text-md text-nowrap">관리중인 장비</h3>
                  <h2 className="text-2xl font-bold">4</h2>
                </div>

                <div className="bg-[#4285F4] w-full text-white p-4 rounded-2xl">
                  <h3 className="text-md text-nowrap">대기중인 작업</h3>
                  <h2 className="text-2xl font-bold">23</h2>
                </div>
                <div className="bg-[#E9E9E9] w-full text-white p-4 rounded-2xl"></div>
                <div className="bg-[#E9E9E9] w-full text-white p-4 rounded-2xl"></div>
              </div>
            </div>
            <div className="p-5 bg-[#F9FAFB] rounded-2xl outline outline-[#E8E8E8] outline-1">
              <div className="flex items-center gap-5 mb-3">
                <div
                  className="ml-5 flex flex-row pointer-events-none select-none"
                  draggable={false}
                >
                  {/* Make it not selectable*/}
                  <div className="w-[140px] h-[140px] scale-[1.7]">
                    <img src={"/assets/images/router.png"} alt="printer" />
                  </div>
                </div>
                <div className="text-start">
                  <h2 className="font-bold text-xl">디자인 바라 1층 작업실</h2>
                  <span>PODRUT-244</span>
                </div>
              </div>
              <div className="flex justify-start gap-3">
                <div className="bg-[#4285F4] w-full text-white p-4 rounded-2xl">
                  <h3 className="text-[15px] text-nowrap">관리중인 장비</h3>
                  <h2 className="text-2xl font-bold">4</h2>
                </div>

                <div className="bg-[#4285F4] w-full text-white p-4 rounded-2xl">
                  <h3 className="text-[15px] text-nowrap">대기중인 작업</h3>
                  <h2 className="text-2xl font-bold">23</h2>
                </div>
                <div className="bg-[#E9E9E9] w-full text-white p-4 rounded-2xl"></div>
                <div className="bg-[#E9E9E9] w-full text-white p-4 rounded-2xl"></div>
              </div>
            </div>
          </div>
        </div>
      </CompanyAdminLayout>
    </>
  );
};

export default NewRoutersPage;
